import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import Skeleton from '@mui/material/Skeleton';

type ItemInfoType = {
  label: string;
  content: string;
  isLoading: boolean;
};

const ItemInfo: React.FC<ItemInfoType> = (props) => {

  return (
    <>
      <Stack mb={'10px'}>
        <Typography fontSize={'12px'} color={'#00000080'}>
          {props.label}
        </Typography>

        {props.isLoading ? (
          <Skeleton width={'100px'} height={'20px'} />
        ) : (
          <Typography fontSize={'14px'} fontWeight={500} color={'#484848'}>
            {props.content}
          </Typography>
        )}
      </Stack>
    </>
  );
};

export default ItemInfo;
